import { useCallback } from 'react';

import { useNavigate } from 'js/hooks/navigate';

import { useCurrentPathAsGameCategory } from './useCurrentPathAsGameCategory';

export const useNavigateToCategoryPath = () => {
    const navigateWithReplace = useNavigate({ replace: true });
    const { gameParentCategory } = useCurrentPathAsGameCategory();

    return useCallback((categoryName) => {
        if (!gameParentCategory) {
            return;
        }

        navigateWithReplace(`${gameParentCategory}/${encodeURI(categoryName)}`, location.state);

    }, [gameParentCategory, navigateWithReplace]);
};
